class ProhTikTokThumbnail extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  async isInIndia() {
    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          timeout: 5000,
          maximumAge: 300000 // 5 minutes
        });
      });
      
      const { latitude, longitude } = position.coords;
      
      // Rough bounding box for India
      const indiaBounds = {
        north: 37.6,
        south: 6.7,
        east: 97.4,
        west: 68.1
      };
        const images = document.querySelectorAll('.proh-social-item__image');
      const isInIndia =
    latitude >= indiaBounds.south &&
    latitude <= indiaBounds.north &&
    longitude >= indiaBounds.west &&
    longitude <= indiaBounds.east;
      if (isInIndia) {
    images.forEach(async (image) => {
    if (image instanceof HTMLImageElement) {
      image.src =
        "/cdn/shop/files/Prohglowbalmpdpimages-10.webp?v=1774983262";

      // Generate srcset with specific widths
      const widths = [360, 540, 720, 960, 1200];

      const srcset = widths
        .map(
          width =>
            `/cdn/shop/files/Prohglowbalmpdpimages-10.webp?v=1774983262&width=${width} ${width}w`
        )
        .join(", ");

      image.srcset = srcset;
    }

    image.setAttribute("loading", "lazy");
      });
  }
    } catch (error) {
      console.log('Geolocation error:', error);
      return false;
    }
  }

  async init() {
    const buttons = document.querySelectorAll('.proh-social-item__button');
    const userInIndia = await this.isInIndia();
    
    buttons.forEach(async (item) => {
      const videoUrl = item.dataset.tiktokUrl;
      
      if (!videoUrl) return;
      
      // Skip TikTok processing if user is in India
      if (userInIndia) {
        console.log('TikTok content blocked - user appears to be in India');
        return;
      }
      
      try {
        const endpoint = `https://www.tiktok.com/oembed?url=${encodeURIComponent(videoUrl)}`;
        const response = await fetch(endpoint);
        const data = await response.json();
        
        const image = item.querySelector('.proh-social-item__image');
        
        if (data.thumbnail_url && image) {
          if (image instanceof HTMLImageElement) {
            image.src = data.thumbnail_url;
            // Generate srcset with specific widths: 360, 540, 720, 960, 1200
            const widths = [360, 540, 720, 960, 1200];
            const srcset = widths.map(width => `${data.thumbnail_url} ${width}w`).join(', ');
            image.srcset = srcset;
          }
          image.setAttribute('loading', 'lazy');
        }
        
      } catch (error) {
        console.log('TikTok thumbnail error:', error);
      }
    });
  }
}

// Auto-initialize the functionality when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const thumbnailComponent = new ProhTikTokThumbnail();
  thumbnailComponent.init();
});

if (!customElements.get('proh-tiktok-thumbnail')) {
  customElements.define('proh-tiktok-thumbnail', ProhTikTokThumbnail);
}
